import { message } from "antd";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import { LoginContainer } from "../../components";
import HTTPClient from "../../utils/HTTPClient";
import { useTranslation } from "react-i18next";

export default function ConfirmEmail({}) {
    const navigate = useNavigate();
    const { token } = useParams();
    const [user, setUser] = useLocalStorage("user", null);
    const { t } = useTranslation();

    useEffect(() => {
        checkToken();
    }, []);

    const handleLogin = async () => {
        let response = await HTTPClient.get("/auth/user");
        const logged_user = {
            ...response.data.user_data,
            wallet: response.data.wallet,
            is_profile_complete: response.data.is_profile_complete,
        };
        setUser(logged_user);
        navigate("/home");
    };

    const checkToken = async () => {
        try {
            await HTTPClient.post("/auth/confirm_email", { token });
            message.success(t("confirm_email.success"));
            await handleLogin();
        } catch (e) {
            const { error_code } = e?.response?.data;
            message.error(t([`errors.${error_code}`, "confirm_email.error"]));
            navigate("/login");
        }
    };

    return <LoginContainer />;
}
